// Portfolio.js
import React, { useState } from "react";
import Categories from "./Categories";
import Projects from "./Projects";
import { portfolio } from "./data";

const allCategories = [
  "All",
  ...new Set(portfolio.map((item) => item.category)),
];

export default function Portfolio() {
  const [menuItems, setMenuItems] = useState(portfolio);
  const [categories, setCategories] = useState(allCategories);

  const filterItems = (category) => {
    if (category === "All") {
      setMenuItems(portfolio);
      return;
    }
    const newItems = portfolio.filter((port) => port.category === category);
    setMenuItems(newItems);
  };

  return (
    <section id="portfolio" className="portfolio section-bg">
      <div className="container">
        <div className="section-title">
          <h2>Portfolio</h2>
          <p>Here are some of the projects I have worked on.</p>
        </div>

        <Categories filterItems={filterItems} categories={categories} />
        <Projects items={menuItems} />
      </div>
    </section>
  );
}
